/** Pedir um serviço ao escritório, em três passos. */
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ComPortal } from '../telas/portal/casca';
import { PedirServico } from '../telas/portal/pedidos';

export const Route = createFileRoute('/portal/pedir')({ validateSearch: z.object({ servico: z.string().optional() }), component: Pagina });
function Pagina() { const { servico } = Route.useSearch(); return <ComPortal>{(d) => <PedirServico d={d} inicial={servico} />}</ComPortal>; }
